// @flow

import React from 'react'
import { StyledHeading } from './styledFormHeaderStyles'

const StyledFormHeader = ({ children }: {children: React$Element<any>}) => <StyledHeading>{children}</StyledHeading>

export default StyledFormHeader
